const KIOSK_URL = 'https://pos-frontend-kappa-two.vercel.app/?mode=kiosk'

export default function Contact() {
  return (
    <div className="py-12 md:py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Get in <span className="text-yellow-500">Touch</span>
          </h1>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Find us inside Prelude Breakfast Bar in downtown Fayetteville.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {/* Location Card */}
          <div className="bg-zinc-900 rounded-3xl p-8 border border-yellow-500/20">
            <div className="w-14 h-14 bg-yellow-500/10 rounded-xl flex items-center justify-center text-yellow-500 mb-6">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-yellow-500 mb-4">Location</h2>
            <div className="text-gray-300 space-y-2">
              <p className="font-medium">Inside Prelude Breakfast Bar</p>
              <p>509 W. Spring Street, Ste 210</p>
              <p className="text-gray-400">Fayetteville, AR</p>
            </div>
            <a
              href="https://www.google.com/maps/search/?api=1&query=509+W+Spring+Street+Fayetteville+AR"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-yellow-500 hover:text-yellow-400 font-semibold"
            >
              Get Directions
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>

          {/* Hours Card */}
          <div className="bg-zinc-900 rounded-3xl p-8 border border-yellow-500/20">
            <div className="w-14 h-14 bg-yellow-500/10 rounded-xl flex items-center justify-center text-yellow-500 mb-6">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-yellow-500 mb-4">Hours</h2>
            <div className="space-y-3">
              <p className="text-gray-300 text-lg font-semibold">Late Night</p>
              <p className="text-gray-400">
                We operate evenings and late night out of Prelude Breakfast Bar.
              </p>
              <p className="text-gray-400 text-sm mt-4">
                Check our Instagram for current hours and availability.
              </p>
            </div>
          </div>
        </div>

        {/* Additional Contact Info */}
        <div className="grid sm:grid-cols-2 gap-6 mb-16">
          {/* Instagram */}
          <a
            href="https://instagram.com/hankypankybuns"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-zinc-900 rounded-2xl p-6 border border-yellow-500/20 text-center hover:border-yellow-500/40 transition-colors"
          >
            <div className="w-12 h-12 bg-yellow-500/10 rounded-full flex items-center justify-center text-yellow-500 mx-auto mb-4">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </div>
            <h3 className="text-white font-semibold mb-2">Instagram</h3>
            <p className="text-gray-400 text-sm">@hankypankybuns</p>
          </a>

          {/* Order Online */}
          <a
            href={KIOSK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-zinc-900 rounded-2xl p-6 border border-yellow-500/20 text-center hover:border-yellow-500/40 transition-colors"
          >
            <div className="w-12 h-12 bg-yellow-500/10 rounded-full flex items-center justify-center text-yellow-500 mx-auto mb-4">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="text-white font-semibold mb-2">Order Online</h3>
            <p className="text-gray-400 text-sm">Quick pickup ordering</p>
          </a>
        </div>

        {/* Map */}
        <div className="bg-zinc-900 rounded-3xl overflow-hidden border border-yellow-500/20 mb-16">
          <div className="aspect-video bg-zinc-800 flex items-center justify-center">
            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-500/10 rounded-full flex items-center justify-center text-yellow-500 mx-auto mb-4">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
              </div>
              <p className="text-gray-300 mb-2 font-medium">509 W. Spring Street, Ste 210</p>
              <p className="text-gray-400 mb-4">Fayetteville, AR</p>
              <a
                href="https://www.google.com/maps/search/?api=1&query=509+W+Spring+Street+Fayetteville+AR"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-6 py-3 bg-yellow-500 hover:bg-yellow-400 text-black font-bold rounded-xl transition-colors"
              >
                Open in Google Maps
              </a>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center bg-gradient-to-br from-yellow-500/10 to-yellow-600/5 rounded-3xl p-8 md:p-12 border border-yellow-500/20">
          <h2 className="text-2xl font-bold text-white mb-4">
            Skip the Wait
          </h2>
          <p className="text-gray-300 mb-6">
            Order online and pick up when you arrive.
          </p>
          <a
            href={KIOSK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-4 bg-yellow-500 hover:bg-yellow-400 text-black font-bold text-lg rounded-xl transition-all hover:scale-105"
          >
            Order Now
          </a>
        </div>
      </div>
    </div>
  )
}
